import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getHourSlots } from '../../Constant.js'
import axios from 'axios'
import Toggle from 'react-toggle'
import Button from '../../common/CustomComponents/Button.js'
class AdditionalHoursAdd extends React.Component {
  state = {
    isLoading: false,
    isSaving: false,

    destinationAddress: [],

    additional_hour_items: [
      {
        additional_hour: '',
        destination_id: '',

        same_price: false,
        enable_b2b_prices: false,

        price: '',
        monday_price: '',
        tuesday_price: '',
        wednesday_price: '',
        thursday_price: '',
        friday_price: '',
        saturday_price: '',

        b2b_price: '',
        b2b_monday_price: '',
        b2b_tuesday_price: '',
        b2b_wednesday_price: '',
        b2b_thursday_price: '',
        b2b_friday_price: '',
        b2b_saturday_price: '',
      },
    ],
  }

  componentDidMount = () => {
    this.getAdditionHours()
    this.getDestinationAddress()
  }

  getDestinationAddress = async () => {
    var cruiseId = this.props.boatId

    await axios
      .get(Constant.getAPI() + `/cruise/list-cruise-destinations/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            destinationAddress: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getAdditionHours = async () => {
    this.setState({ isloading: true })
    var cruiseId = this.props.boatId
    await axios
      .get(Constant.getAPI() + `/cruise/list-cruise-additional-hour/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          if (this.props.additional_hour_id) {
            // Edit mode - find and populate the specific additional hour
            const matchItem = res.data.data.find((itm) => itm.id === this.props.additional_hour_id)
            if (matchItem) {
              this.setState({
                additional_hour_items: [
                  {
                    additional_hour: matchItem.additional_hour,
                    destination_id: matchItem.destination_id,
                    same_price: matchItem.same_price,
                    enable_b2b_prices: matchItem.enable_b2b_prices,
                    price: matchItem.price,
                    monday_price: matchItem.monday_price,
                    tuesday_price: matchItem.tuesday_price,
                    wednesday_price: matchItem.wednesday_price,
                    thursday_price: matchItem.thursday_price,
                    friday_price: matchItem.friday_price,
                    saturday_price: matchItem.saturday_price,
                    b2b_price: matchItem.b2b_price,
                    b2b_monday_price: matchItem.b2b_monday_price,
                    b2b_tuesday_price: matchItem.b2b_tuesday_price,
                    b2b_wednesday_price: matchItem.b2b_wednesday_price,
                    b2b_thursday_price: matchItem.b2b_thursday_price,
                    b2b_friday_price: matchItem.b2b_friday_price,
                    b2b_saturday_price: matchItem.b2b_saturday_price,
                  },
                ],
              })
            }
          } else {
            // Add mode - initialize with empty item
            this.setState({
              additional_hour_items: [
                {
                  additional_hour: '',
                  destination_id: '',
                  same_price: false,
                  enable_b2b_prices: false,
                  price: '',
                  monday_price: '',
                  tuesday_price: '',
                  wednesday_price: '',
                  thursday_price: '',
                  friday_price: '',
                  saturday_price: '',
                  b2b_price: '',
                  b2b_monday_price: '',
                  b2b_tuesday_price: '',
                  b2b_wednesday_price: '',
                  b2b_thursday_price: '',
                  b2b_friday_price: '',
                  b2b_saturday_price: '',
                },
              ],
            })
          }
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isloading: false })
      })
  }

  addAdditionalHours = async () => {
    this.setState({ isSaving: true })
    const cruiseId = this.props.boatId
    let successCount = 0
    let errorCount = 0

    try {
      for (const item of this.state.additional_hour_items) {
        const data = {
          cruise_id: cruiseId,
          additional_hour: item.additional_hour,
          destination_id: item.destination_id,
          price: item.price,
          monday_price: item.same_price ? item.price : item.monday_price,
          tuesday_price: item.same_price ? item.price : item.tuesday_price,
          wednesday_price: item.same_price ? item.price : item.wednesday_price,
          thursday_price: item.same_price ? item.price : item.thursday_price,
          friday_price: item.same_price ? item.price : item.friday_price,
          saturday_price: item.same_price ? item.price : item.saturday_price,
          b2b_price: item.enable_b2b_prices ? item.b2b_price || null : null,
          b2b_monday_price: item.enable_b2b_prices
            ? (item.same_price ? item.b2b_price : item.b2b_monday_price) || null
            : null,
          b2b_tuesday_price: item.enable_b2b_prices
            ? (item.same_price ? item.b2b_price : item.b2b_tuesday_price) || null
            : null,
          b2b_wednesday_price: item.enable_b2b_prices
            ? (item.same_price ? item.b2b_price : item.b2b_wednesday_price) || null
            : null,
          b2b_thursday_price: item.enable_b2b_prices
            ? (item.same_price ? item.b2b_price : item.b2b_thursday_price) || null
            : null,
          b2b_friday_price: item.enable_b2b_prices
            ? (item.same_price ? item.b2b_price : item.b2b_friday_price) || null
            : null,
          b2b_saturday_price: item.enable_b2b_prices
            ? (item.same_price ? item.b2b_price : item.b2b_saturday_price) || null
            : null,
          enable_b2b_prices: !!item.enable_b2b_prices,
        }

        let response
        if (this.props.additional_hour_id) {
          // Edit mode
          data.additional_hour_id = this.props.additional_hour_id
          response = await axios.put(Constant.getAPI() + `/cruise/update-cruise-additional-hour`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
        } else {
          // Add mode
          response = await axios.post(Constant.getAPI() + '/cruise/add-cruise-additional-hour', data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
        }

        if (response.status === 200) {
          successCount++
        } else {
          errorCount++
        }
      }

      // Show success message after all items are saved
      if (successCount > 0) {
        const message = this.props.additional_hour_id
          ? 'Additional Hours Updated Successfully!'
          : 'Additional Hours Added Successfully!'

        await Swal.fire({
          title: message,
          text: `Successfully processed ${successCount} item(s)${errorCount > 0 ? `, but ${errorCount} item(s) failed` : ''}`,
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })

        // Redirect after successful save
        window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/additionhours-lists`
      }
    } catch (err) {
      errorCount++
      if (err?.response?.status === 401) {
        Constant.getAuthLogout()
      } else {
        await Swal.fire({
          title:
            err?.response?.data?.data?.details?.[0]?.message ||
            err?.response?.data?.message ||
            'An error occurred while saving the items',
          text: `Successfully processed ${successCount} item(s), but ${errorCount} item(s) failed`,
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })
      }
    } finally {
      this.setState({ isSaving: false, isLoading: false })
    }
  }

  onSaveData = () => {
    // Validate each additional hour item
    const invalidItems = this.state.additional_hour_items.filter((item) => {
      return !item.additional_hour || !item.destination_id || !item.price
    })

    if (invalidItems.length > 0) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all required fields (Additional Hours, Destination Address, and Price)',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      })
      return
    }

    // Validate B2B prices if enabled
    const invalidB2BItems = this.state.additional_hour_items.filter((item) => {
      if (item.enable_b2b_prices) {
        return !item.b2b_price
      }
      return false
    })

    if (invalidB2BItems.length > 0) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in B2B prices for items where B2B pricing is enabled',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      })
      return
    }

    // Validate daily prices if same_price is false
    const invalidDailyPrices = this.state.additional_hour_items.filter((item) => {
      if (!item.same_price) {
        return (
          !item.monday_price ||
          !item.tuesday_price ||
          !item.wednesday_price ||
          !item.thursday_price ||
          !item.friday_price ||
          !item.saturday_price
        )
      }
      return false
    })

    if (invalidDailyPrices.length > 0) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all daily prices when "Same Price" is disabled',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      })
      return
    }

    // Validate B2B daily prices if same_price is false and B2B is enabled
    const invalidB2BDailyPrices = this.state.additional_hour_items.filter((item) => {
      if (item.enable_b2b_prices && !item.same_price) {
        return (
          !item.b2b_monday_price ||
          !item.b2b_tuesday_price ||
          !item.b2b_wednesday_price ||
          !item.b2b_thursday_price ||
          !item.b2b_friday_price ||
          !item.b2b_saturday_price
        )
      }
      return false
    })

    if (invalidB2BDailyPrices.length > 0) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all B2B daily prices when "Same Price" is disabled and B2B pricing is enabled',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      })
      return
    }

    this.addAdditionalHours()
  }

  addAdditionalHoursItem = () => {
    this.setState({ additional_hour_items: [...this.state.additional_hour_items, {}] })
  }

  removeAdditionalHoursItem = (index) => {
    this.setState({ additional_hour_items: this.state.additional_hour_items.filter((_, i) => i !== index) })
  }

  render() {
    return (
      <div className="card-body p-0 pr-3 pl-3">
        {this.state.additional_hour_items.map((item, index) => (
          <div
            className="row border border-secondary rounded p-3 mb-2 bg-light"
            key={index}
          >
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Destination Address</label>
                <div className="col-sm-9">
                  <select
                    name={`destination_id_${index}`}
                    className="form-control"
                    onChange={(e) => {
                      const newItems = [...this.state.additional_hour_items]
                      newItems[index] = {
                        ...newItems[index],
                        destination_id: e.target.value,
                      }
                      this.setState({ additional_hour_items: newItems })
                    }}
                    value={item.destination_id || ''}
                  >
                    <option>Select Destination Address</option>
                    {this.state.destinationAddress && this.state.destinationAddress.length > 0
                      ? this.state.destinationAddress.map((destinationAddress) => (
                          <option
                            value={destinationAddress.id}
                            key={destinationAddress.id}
                          >
                            {destinationAddress.destination_address_en}
                            {' ('}
                            {destinationAddress.destination_min_hour})
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Additional Hours</label>
                <div className="col-sm-9">
                  <select
                    name={`additional_hour_${index}`}
                    className="form-control"
                    value={item.additional_hour || ''}
                    onChange={(e) => {
                      const newItems = [...this.state.additional_hour_items]
                      newItems[index] = {
                        ...newItems[index],
                        additional_hour: e.target.value,
                      }
                      this.setState({ additional_hour_items: newItems })
                    }}
                  >
                    <option>Select time(HH:MM)</option>
                    {getHourSlots().map(
                      (slot) =>
                        slot.value != '00:00:00' && (
                          <option
                            value={slot.value}
                            key={slot.value}
                          >
                            {slot.label}
                          </option>
                        )
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Same Price</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name={`same_price_${index}`}
                    id={`same_price_${index}`}
                    onChange={(e) => {
                      const newItems = [...this.state.additional_hour_items]
                      newItems[index] = {
                        ...newItems[index],
                        same_price: e.target.checked,
                      }
                      this.setState({ additional_hour_items: newItems })
                    }}
                    checked={item.same_price || false}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Enable B2B Prices</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name={`enable_b2b_prices_${index}`}
                    id={`enable_b2b_prices_${index}`}
                    onChange={(e) => {
                      const newItems = [...this.state.additional_hour_items]
                      newItems[index] = {
                        ...newItems[index],
                        enable_b2b_prices: e.target.checked,
                      }
                      this.setState({ additional_hour_items: newItems })
                    }}
                    checked={item.enable_b2b_prices || false}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Normal Price</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">{item.same_price ? 'Price' : 'Sunday Price'}</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name={`price_${index}`}
                    placeholder="Price"
                    onChange={(e) => {
                      const newItems = [...this.state.additional_hour_items]
                      newItems[index] = {
                        ...newItems[index],
                        price: e.target.value,
                      }
                      this.setState({ additional_hour_items: newItems })
                    }}
                    value={item.price || ''}
                  />
                </div>
              </div>
            </div>
            {!item.same_price && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Monday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name={`monday_price_${index}`}
                        placeholder="Monday Price"
                        onChange={(e) => {
                          const newItems = [...this.state.additional_hour_items]
                          newItems[index] = {
                            ...newItems[index],
                            monday_price: e.target.value,
                          }
                          this.setState({ additional_hour_items: newItems })
                        }}
                        value={item.monday_price || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Tuesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name={`tuesday_price_${index}`}
                        placeholder="Tuesday Price"
                        onChange={(e) => {
                          const newItems = [...this.state.additional_hour_items]
                          newItems[index] = {
                            ...newItems[index],
                            tuesday_price: e.target.value,
                          }
                          this.setState({ additional_hour_items: newItems })
                        }}
                        value={item.tuesday_price || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Wednesday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name={`wednesday_price_${index}`}
                        placeholder="Wednesday Price"
                        onChange={(e) => {
                          const newItems = [...this.state.additional_hour_items]
                          newItems[index] = {
                            ...newItems[index],
                            wednesday_price: e.target.value,
                          }
                          this.setState({ additional_hour_items: newItems })
                        }}
                        value={item.wednesday_price || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Thursday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name={`thursday_price_${index}`}
                        placeholder="Thursday Price"
                        onChange={(e) => {
                          const newItems = [...this.state.additional_hour_items]
                          newItems[index] = {
                            ...newItems[index],
                            thursday_price: e.target.value,
                          }
                          this.setState({ additional_hour_items: newItems })
                        }}
                        value={item.thursday_price || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Friday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name={`friday_price_${index}`}
                        placeholder="Friday Price"
                        onChange={(e) => {
                          const newItems = [...this.state.additional_hour_items]
                          newItems[index] = {
                            ...newItems[index],
                            friday_price: e.target.value,
                          }
                          this.setState({ additional_hour_items: newItems })
                        }}
                        value={item.friday_price || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Saturday Price</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name={`saturday_price_${index}`}
                        placeholder="Saturday Price"
                        onChange={(e) => {
                          const newItems = [...this.state.additional_hour_items]
                          newItems[index] = {
                            ...newItems[index],
                            saturday_price: e.target.value,
                          }
                          this.setState({ additional_hour_items: newItems })
                        }}
                        value={item.saturday_price || ''}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {item.enable_b2b_prices && (
              <>
                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                >
                  <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>B2B Price</div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">{item.same_price ? 'Price' : 'Sunday Price'}</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name={`b2b_price_${index}`}
                        placeholder="Price"
                        onChange={(e) => {
                          const newItems = [...this.state.additional_hour_items]
                          newItems[index] = {
                            ...newItems[index],
                            b2b_price: e.target.value,
                          }
                          this.setState({ additional_hour_items: newItems })
                        }}
                        value={item.b2b_price || ''}
                      />
                    </div>
                  </div>
                </div>
                {!item.same_price && (
                  <>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Monday Price</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name={`b2b_monday_price_${index}`}
                            placeholder="Monday Price"
                            onChange={(e) => {
                              const newItems = [...this.state.additional_hour_items]
                              newItems[index] = {
                                ...newItems[index],
                                b2b_monday_price: e.target.value,
                              }
                              this.setState({ additional_hour_items: newItems })
                            }}
                            value={item.b2b_monday_price || ''}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Tuesday Price</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name={`b2b_tuesday_price_${index}`}
                            placeholder="Tuesday Price"
                            onChange={(e) => {
                              const newItems = [...this.state.additional_hour_items]
                              newItems[index] = {
                                ...newItems[index],
                                b2b_tuesday_price: e.target.value,
                              }
                              this.setState({ additional_hour_items: newItems })
                            }}
                            value={item.b2b_tuesday_price || ''}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Wednesday Price</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name={`b2b_wednesday_price_${index}`}
                            placeholder="Wednesday Price"
                            onChange={(e) => {
                              const newItems = [...this.state.additional_hour_items]
                              newItems[index] = {
                                ...newItems[index],
                                b2b_wednesday_price: e.target.value,
                              }
                              this.setState({ additional_hour_items: newItems })
                            }}
                            value={item.b2b_wednesday_price || ''}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Thursday Price</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name={`b2b_thursday_price_${index}`}
                            placeholder="Thursday Price"
                            onChange={(e) => {
                              const newItems = [...this.state.additional_hour_items]
                              newItems[index] = {
                                ...newItems[index],
                                b2b_thursday_price: e.target.value,
                              }
                              this.setState({ additional_hour_items: newItems })
                            }}
                            value={item.b2b_thursday_price || ''}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Friday Price</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name={`b2b_friday_price_${index}`}
                            placeholder="Friday Price"
                            onChange={(e) => {
                              const newItems = [...this.state.additional_hour_items]
                              newItems[index] = {
                                ...newItems[index],
                                b2b_friday_price: e.target.value,
                              }
                              this.setState({ additional_hour_items: newItems })
                            }}
                            value={item.b2b_friday_price || ''}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Saturday Price</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name={`b2b_saturday_price_${index}`}
                            placeholder="Saturday Price"
                            onChange={(e) => {
                              const newItems = [...this.state.additional_hour_items]
                              newItems[index] = {
                                ...newItems[index],
                                b2b_saturday_price: e.target.value,
                              }
                              this.setState({ additional_hour_items: newItems })
                            }}
                            value={item.b2b_saturday_price || ''}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            {this.state.additional_hour_items.length > 1 && (
              <div className="col-md-6 text-right">
                <Button
                  onClick={() => this.removeAdditionalHoursItem(index)}
                  disabled={this.state.isLoading}
                  variant={'outlined'}
                  color={'secondary'}
                >
                  Remove
                </Button>
              </div>
            )}
          </div>
        ))}
        <div className="card-footer">
          <div className="row">
            <div
              className={`text-right col-12 p-0 d-flex ${
                !this.props.additional_hour_id ? 'justify-content-between' : 'justify-content-end'
              }`}
            >
              {!this.props.additional_hour_id && (
                <Button
                  onClick={this.addAdditionalHoursItem}
                  disabled={this.state.isLoading}
                  variant={'outlined'}
                >
                  Add More
                </Button>
              )}

              <Button
                onClick={this.onSaveData}
                startIcon={<i className="ti-save"></i>}
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? 'Saving...!' : 'Save'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdditionalHoursAdd
